import { useMemo } from "react";

import { GetObjectHashValue } from "shared/helpers/DataHelpers";
import { createModernFilter } from "shared/helpers/JaqlHelpers";
import { useParentCompanyLocationValidation } from "components/hooks/useParentCompanyLocationValidation";
import { filter } from "lodash";

export function useGetHomepageSisenseWidgetArgs(metricLocations) {
  const { eraOnly } = useParentCompanyLocationValidation();

  function createFilters(dim, sourceLocations) {
    const memberValues = sourceLocations.map((x) => x.value);
    return [
      {
        jaql: {
          dim: dim,
          datatype: "numeric",
          filter: createModernFilter(memberValues),
        },
      },
    ];
  }

  const getFilterString = (srcFilter) => {
    if (srcFilter.length > 0) {
      return encodeURIComponent(JSON.stringify(srcFilter));
    }
  };

  let metricSisensLocations =
    !eraOnly && metricLocations != null && metricLocations.length > 0
      ? metricLocations
      : [{ value: -1 }];

  function GetAgingWidgetUrl() {
    const agingFilters = createFilters(
      "[vwAging_Sisense.SecurityID]",
      metricSisensLocations
    );

    let dashboard = process.env.REACT_APP_Dashboard_Aging;

    let url = `${
      process.env.REACT_APP_SisenseURI
    }/app/main#/dashboards/${dashboard}?embed=true&filter=${getFilterString(
      agingFilters
    )}&h=false&r=false&t=false&l=false&edit=false`;

    return url;
  }

  function GetFeeAndAdjustmentWidgetUrl() {
    const adjustmentTrackerFilters = createFilters(
      "[vwFeeAdjustment_Sisense.SecurityID]",
      metricSisensLocations
    );

    let dashboard = process.env.REACT_APP_Dashboard_Adjustments;

    let url = `${
      process.env.REACT_APP_SisenseURI
    }/app/main#/dashboards/${dashboard}?embed=true&filter=${getFilterString(
      adjustmentTrackerFilters
    )}&h=false&r=false&t=false&l=false&edit=false`;

    return url;
  }

  function GetSourceLocationsHash() {
    let sourceFilterHash = GetObjectHashValue(metricSisensLocations);

    return sourceFilterHash;
  }

  const sisenseArgs = useMemo(() => {
    //alert("sisenseArgs");
    return {
      agingSisenseUrl: GetAgingWidgetUrl(),
      feeAdjustjentSisenseUrl: GetFeeAndAdjustmentWidgetUrl(),
      filterHash: GetSourceLocationsHash(),
    };
  }, [metricSisensLocations]);

  return { sisenseArgs };
}
